import { BOverlay } from './overlay';
import { pluginFactory } from '../../utils/plugins';
var OverlayPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BOverlay: BOverlay
  }
});
export { OverlayPlugin, BOverlay };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/overlay/index.js
// module id = S9e5
// module chunks = 5